import ContentPanel from './ContentPanel';
import { Description, H2 } from './utils';

const MetricsSection = ({
  title,
  description,
  items,
}: {
  title: string;
  description: string;
  items: {
    numberText: string;
    headline: string;
    description: string;
  }[];
}) => {
  return (
    <ContentPanel>
      <H2>{title}</H2>
      <Description>{description}</Description>
      <div className='grid grid-cols-1 sm:grid-cols-4 gap-8'>
        {items.map((item, index) => (
          <div key={index} className='flex flex-col items-center text-center'>
            <div className='text-5xl font-semibold text-brand-500'>{item.numberText}</div>
            <div className='mt-3 text-lg font-semibold leading-7 text-gray-900'>
              {item.headline}
            </div>
            <div className='mt-2 text-gray-600'>{item.description}</div>
          </div>
        ))}
      </div>
    </ContentPanel>
  );
};

export default MetricsSection;
